<app-breadcrumb [links]="links" current="Produtos"></app-breadcrumb>

<div class="backgroundColor star-dust darken-3">
  <section class="container-fluid backgroundColor star-dust darken-3 position-relative top-119" id="my-element">
    <div class="container mb-5">
      <div class="row pt-20 pb-10 d-flex justify-content-center">
        <div class="col-6">
          <h1 class="text-white text-shadow">Inserir Produtos</h1>
        </div>
      </div>
      <div class="row d-flex justify-content-between mt-20">
        <div class="col-12 col-md-12 col-lg-4 fixedHeight">
          <ng-container *ngFor="let item of produtos">
            <div class="row mb-2 no-padd">
              <div class="card p-4 d-flex justify-content-center model-border card-w">
                <div class="row no-gutters">
                  <div class="col-md-5 my-auto">
                    <img src="https://{{apiUrl}}/api/produtos/image/{{item.id}}/{{item.media?.split(';')[0]}}/" alt="..." class="img-fluid my-auto">
                  </div>
                  <div class="col-md-6">
                    <div class="card-body text-center">
                      <h2 class="card-title text-white card-text-limit">{{getMarca(item)}}</h2>
                      <h2 class="my-auto card-title text-white card-text-limit">{{item.nome}}</h2>
                      <div class="d-flex justify-content-center pt-4">
                        <button class="btn harvest-gold base card-link" (click)="delete(item)"><fa-icon [icon]="faTrash" class="fal fa-trash"></fa-icon></button>
                        <button class="btn shark lighten-3 card-link" (click)="bind(item)"><fa-icon [icon]="faPencilAlt" class="fal fa-pencil-alt"></fa-icon></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="col-12 col-md-12 col-lg-7 backgroundColor shark base py-10 mt-5">
          <app-selector class="text-white" [(selection)]="tipo" title="Tipo" [(selected)]="selTipo" [multiple]="true" (change)="changeType($event)"></app-selector>
          <app-selector class="text-white" [(selection)]="marcas" title="Marcas" [(selected)]="marcaSel" [multiple]="false" [(disable)]="disableMarcas"></app-selector>
          <div class="form-group">
            <label class="text-white">Nome / Modelo</label>&nbsp;
            <input class="form-control" type="text" [(ngModel)]="model.nome">
          </div>
          <div class="form-group">
            <label class="text-white">Coleção</label>&nbsp;
            <input class="form-control" type="text" [(ngModel)]="model.colecao">
          </div>
          <div class="form-group">
            <label class="text-white">Descrição</label>&nbsp;
            <textarea class="form-control" rows="6" type="text" [(ngModel)]="model.desc"></textarea>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-6">
                <label class="text-white">Preço</label>
                <input class="form-control" type="number" [(ngModel)]="model.preco">
              </div>
              <div class="col-6">
                <label class="text-white">Referência</label>&nbsp;
                <input class="form-control" type="text" [(ngModel)]="model.ref">
              </div>
            </div>
          </div>
          <app-Carecteristicas class="text-white" [(output)]="model.carecteristicas"></app-Carecteristicas>
          <app-imageInput class="text-white" titulo="Imagens" btn="Ficheiros" [(models)]="model.media" [multiple]="true"></app-imageInput>
          <span class="textColor white base">A primeira imagem carregada será definida como a principal</span><br>
          <div class="mt-10">
            <button type="submit" class="btn btn-primary mr-5" (click)="send()">Submeter</button>
            <button type="submit" class="btn btn-secondary" (click)="clear()">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>